import { css } from "lit-element";
export default css `
:host {
  font-family: "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif;
  line-height: 1.5;
}

.container {
  width: calc(100% - 1em);
  margin-right: auto;
  margin-left: auto;
  padding: 0.5em;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

h1,
.h1 {
  font-size: 2.5rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

.header {
  border-bottom: 1px solid #e5e5e5;
}
`;
